module.exports = __webpack_public_path__ + "img/opa_scrable.4306b08b.jpg";